import {TaskOperatorComponent} from './task-operator/task-operator.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {IdentificationDataOperatorComponent} from './identification-data/identification-data-operator.component';
import {NotificationsOperatorComponent} from './notifications-operator/notifications-operator.component';
import {ElectricityOperatorComponent} from './electricity-operator/electricity-operator.component';
import {GasOperatorComponent} from './gas-operator/gas-operator.component';
import {NetworkContractTaskComponent} from './task-operator/details/network-contract-task/network-contract-task.component';
import {ElectricityConsumptionPlaceComponent} from './electricity-operator/consumption-place/electricity-consumption-place.component';
import {GasConsumptionPlaceComponent} from './gas-operator/consumption-place/gas-consumption-place.component';
import {ImpossibilitySupplyComponent} from './impossibility-supply/impossibility-supply.component';
import {OperatorAuthGuard} from 'src/app/shared/guard/operatorAuth.guard';
import {OperatorInvitationsComponent} from './identification-data/details/operator-invitations.component';
import {NetworkContractElectricityComponent} from "./electricity-operator/network-contract/network-contract-electricity.component";
import {NetworkContractGasComponent} from "./gas-operator/network-contract/network-contract-gas.component";
import { ContractIndexComponent } from 'src/app/public/contract-index/contract-index.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'date-identificare',
        component: IdentificationDataOperatorComponent,
        data: {
          breadcrumb: 'Date identificare'
        }
      },
      {
        path: 'invitatii',
        component: OperatorInvitationsComponent,
        data: {
          // title: 'Furnizor',
          breadcrumb: 'Conturi'
        }
      },
      {
        path: 'task-uri',
        component: TaskOperatorComponent,
        data: {
          breadcrumb: 'Task-uri'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'task-uri/contract-retea',
        component: NetworkContractTaskComponent,
        data: {
          breadcrumb: 'Contractare serviciu de retea'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'notificari',
        component: NotificationsOperatorComponent,
        data: {
          breadcrumb: 'Notificari'
        }//,
        //canActivate: [OperatorAuthGuard]
      },
      {
        path: 'energie-electrica',
        component: ElectricityOperatorComponent,
        data: {
          breadcrumb: 'Energie Electrica'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'energie-electrica/imposibilitate-furnizare',
        component: ImpossibilitySupplyComponent,
        data: {
          breadcrumb: 'Energie Electrica'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'energie-electrica/adaugare-loc-consum',
        component: ElectricityConsumptionPlaceComponent,
        data: {
          breadcrumb: 'Adaugare loc consum energie electrica'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'energie-electrica/editare-loc-consum',
        component: ElectricityConsumptionPlaceComponent,
        data: {
          breadcrumb: 'Editare loc consum energie electrica'
        }
      },
      {
        path: 'energie-electrica/detalii-loc-consum',
        component: ElectricityConsumptionPlaceComponent,
        data: {
          breadcrumb: 'Detalii loc consum energie electrica'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'energie-electrica/index',
        component: ContractIndexComponent,
        data: {
          breadcrumb: 'Trimitere index'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'gaze-naturale/adaugare-loc-consum',
        component: GasConsumptionPlaceComponent,
        data: {
          breadcrumb: 'Adaugare loc consum gaze naturale'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'gaze-naturale/editare-loc-consum',
        component: GasConsumptionPlaceComponent,
        data: {
          breadcrumb: 'Editare loc consum gaze naturale'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'gaze-naturale/detalii-loc-consum',
        component: GasConsumptionPlaceComponent,
        data: {
          breadcrumb: 'Detalii loc consum gaze naturale'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'gaze-naturale/index',
        component: ContractIndexComponent,
        data: {
          breadcrumb: 'Trimitere index'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'gaze-naturale',
        component: GasOperatorComponent,
        data: {
          breadcrumb: 'Gaze Naturale'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'gaze-naturale/imposibilitate-furnizare',
        component: ImpossibilitySupplyComponent,
        data: {
          breadcrumb: 'Energie Electrica'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'energie-electrica/adaugare-contract-de-retea',
        component: NetworkContractElectricityComponent,
        data: {
          breadcrumb: 'Adaugare contract de retea energie electrica'
        },
        canActivate: [OperatorAuthGuard]
      }
      ,
      {
        path: 'gaze-naturale/adaugare-contract-de-retea',
        component: NetworkContractGasComponent,
        data: {
          breadcrumb: 'Adaugare contract de retea gaz'
        },
        canActivate: [OperatorAuthGuard]
      },
      {
        path: 'energie-electrica/detalii-contract-de-retea',
        component: NetworkContractElectricityComponent,
        data: {
          breadcrumb: 'Detalii contract de retea energie electrica'
        },
        canActivate: [OperatorAuthGuard]
      }
      ,
      {
        path: 'gaze-naturale/detalii-contract-de-retea',
        component: NetworkContractGasComponent,
        data: {
          breadcrumb: 'Detalii contract de retea gaz'
        },
        canActivate: [OperatorAuthGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OperatorRoutingModule {
}
